var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPencilRubberIconSv(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "icon pencil-rubber-icon",
    viewBox: "16 16 28 28",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.745 40.845a.518.518 0 01-.163.109l-7.218 2.972a.99.99 0 01-1.29-1.291l2.972-7.217a.49.49 0 01.11-.163l18.096-18.097a3.952 3.952 0 115.59 5.59L24.745 40.845zm11.11-19.495L21.878 35.325l2.795 2.795L38.65 24.145l-2.796-2.795zm2.795-2.795l-1.398 1.398 2.795 2.795 1.398-1.398a1.976 1.976 0 10-2.795-2.795zM20.598 36.84l-1.793 4.355 4.355-1.793-2.562-2.562z"
  })));
}

export default SvgPencilRubberIconSv;